/* eslint-disable @typescript-eslint/no-explicit-any */
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { TableData } from '@/components/Table/types';
import { formatDateAndTime } from './formatDate';

const DEFAULT_FILE_NAME = 'Montecon';

type ExportPdfArgs = {
  data: TableData;
  fileName?: string;
  selectedColumns?: string[];
  adjustTitles?: boolean;
};

const formatColumnTitle = (title: string): string => {
  return title
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase())
    .replace(/ ([A-Z])/g, (str) => str.toLowerCase());
};

export const exportPdf = ({
  data,
  fileName = DEFAULT_FILE_NAME,
  selectedColumns = [],
  adjustTitles = false,
}: ExportPdfArgs) => {
  // eslint-disable-next-line new-cap
  const doc = new jsPDF({
    orientation: 'landscape',
    format: 'a2',
  });

  let columns: string[];

  if (selectedColumns.length > 0) {
    columns = selectedColumns;
  } else if (data.length > 0) {
    columns = Object.keys(data[0]);
  } else {
    columns = [];
  }

  const formattedColumns = columns.map(formatColumnTitle);

  const rows = data.map((item) =>
    columns.map((column) => {
      const value = item[column];
      if (value instanceof Date) {
        return formatDateAndTime(value.toISOString());
      }
      return value || '';
    })
  );

  const styles = {
    fontSize: 8,
    cellPadding: 2,
    overflow: 'linebreak',
    cellWidth: 'wrap',
  };

  const pageContent = (tableData: any) => {
    doc.setFontSize(10);
    doc.text('Montecon Report', tableData.settings.margin.left, 10);
  };

  const headerStyles = {
    fillColor: '#E7EEF5', // Color de fondo para los encabezados
    textColor: '#223466', // Color del texto para los encabezados
    fontSize: 8,
    cellPadding: 2,
    lineWidth: 0.5,
  };

  (doc as any).autoTable({
    head: [
      adjustTitles
        ? formattedColumns.map((title) => title.split(' ').join('\n'))
        : formattedColumns,
    ],
    body: rows,
    styles,
    columnStyles: {
      0: { cellWidth: 'auto' },
    },
    theme: 'grid',
    pageBreak: 'auto',
    tableWidth: 'auto',
    didDrawPage: pageContent,
    headStyles: headerStyles,
  });

  doc.save(`${fileName}.pdf`);
};
